<template>
  <div class="wrapper">
    <div class="login-card">
      <div class="login-card-header">
        <img
          :src="require(`@/assets/logos/uc_carsharing_roxo.png`)"
          alt="pickndrive"
          style="width: 240px; margin-bottom: 12%; margin-top: 5%;"
        />
      </div>
      <form @submit.prevent="login">
        <div class="form-group text-center">
          <label for="email-input">E-mail</label>
          <input
            type="email"
            class="form-control"
            v-model="email"
            id="email-input"
            aria-describedby="emailHelp"
            placeholder="seuemail@host.com.br"
          />
        </div>
        <div class="form-group text-center">
          <label for="password-input">Senha</label>
          <div class="input-group mb-3">
            <input
              :type="UI.passwordInputType"
              v-model="password"
              id="password-input"
              class="form-control"
              placeholder="Senha do usuário"
              aria-label="Senha do usuário"
              aria-describedby="basic-addon2"
            />
            <div class="input-group-append">
              <span
                class="input-group-text change-visibility-span"
                id="basic-addon2"
                @click="showPassword"
                >{{ UI.passwordInputButton }}</span
              >
            </div>
          </div>
        </div>
        <div class="form-group">
          <label for="rememberMe" class="remember-me">
            <input
              type="checkbox"
              v-model="UI.rememberMe"
              id="rememberMe"
              class="form-control"
              placeholder="Senha do usuário"
            />
            <span>Lembrar de mim</span>
          </label>
        </div>
        <div class="form-group text-center" v-if="clients.length >= 1">
          <label for="email-input">Escolha um cliente</label>
          <select
            class="form-control"
            v-model="client_id"
            id="exampleFormControlSelect1"
          >
            <option
              v-for="client in clients"
              :value="client.id"
              :key="client.name"
              >{{ client.name }}</option
            >
          </select>
        </div>
        <div class="forgot-password">
          <router-link :to="{ name: 'registerUser' }"> Cadastre-se</router-link>
          <v-spacer></v-spacer>
          <router-link :to="{ name: 'forgotPassword' }">
            Esqueceu sua senha?</router-link
          >
        </div>
        <button
          :disabled="UI.isLoggingIn"
          type="submit"
          class="btn white--text btn-block"
        >
          {{ UI.isLoggingIn ? "Carregando" : "LOGIN" }}
        </button>
      </form>
      <div class="py-3 text-center">
        <router-link
          class="subheading font-weight-medium help"
          to="/publicHelp"
        >
          Ajuda <v-icon size="20" class="pl-1" color="#9fd7f8">help</v-icon>
        </router-link>
      </div>
    </div>
    <footer class="text-right">v.{{ version_app }}</footer>
  </div>
</template>

<script>
import AuthController from "../../controllers/AuthController.js";
import theming from "../../mixins/theming";
import Roles from "../../models/Roles";
import packageJsonValues from "../../../package.json";

export default {
  mixins: [theming],
  data() {
    return {
      isCordova() {
        if (
          (document.URL.indexOf("http://") === -1 &&
            document.URL.indexOf("https://") === -1) ||
          !!window.cordova
        ) {
          return true;
        }

        return false;
      },
      email: null,
      password: null,
      blnVisibleComboClient: false,
      client_id: null,
      clients: [],
      UI: {
        isLoggingIn: false,
        passwordInputType: "password",
        passwordInputButton: "Mostrar",
        rememberMe: true
      },
      version_app: null
    };
  },

  created() {
    this.authController = new AuthController(
      this.$resource,
      this.$router,
      this.$message
    );
    this.getVersion();
  },
  beforeRouteEnter(to, from, next) {
    let rememberMe = localStorage.getItem("remember_me");
    let accessToken = localStorage.getItem("access_token");

    if (!(rememberMe && accessToken)) {
      localStorage.clear();
      return next();
    }

    let user_profile = localStorage.getItem("profile");

    if (user_profile === Roles.User) {
      return next({ name: "driver-vehicle-request-dashboard" });
    } else {
      localStorage.clear();
      return next();
    }
  },
  methods: {
    detectar_mobile() {
      var check = false; //wrapper no check
      (function(a) {
        if (
          /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
            a
          ) ||
          /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
            a.substr(0, 4)
          )
        )
          check = true;
      })(navigator.userAgent || navigator.vendor || window.opera);
      return check;
    },

    navegador() {
      // if(this.detectar_mobile()){
      //   if(navigator.userAgent.contains('Android'))
      // }
      alert(navigator.userAgent);
    },
    async login() {
      try {
        this.UI.isLoggingIn = true;
        await this.authController
          .login(this.email, this.password, this.client_id)
          .then(response => {
            if (this.UI.rememberMe) {
              localStorage.setItem("remember_me", String(true));
            }
            if (response != undefined) this.clients = response;
            this.UI.isLoggingIn = false;
          });
      } catch (error) {
        this.UI.isLoggingIn = false;
        console.log(error);
      }
    },
    showPassword() {
      let type = this.UI.passwordInputType;

      if (type === "password") {
        this.UI.passwordInputType = "text";
        this.UI.passwordInputButton = "Esconder";
        return;
      }

      this.UI.passwordInputButton = "Mostrar";
      this.UI.passwordInputType = "password";
    },
    showClientsCombo() {
      return this.clients.length > 0 ? true : false;
    },
    changeTextValue() {
      this.clients = [];
      this.client_id = null;
    },
    getVersion() {
      this.version_app = packageJsonValues.version;
    }
  }
};
</script>

<style scoped lang="scss">
.help {
  text-decoration: none;
}

a:hover {
  cursor: pointer;
}

.wrapper {
  position: fixed;
  width: 100vw;
  height: 100%;
  /*background: url('../../assets/background-desktop.png');*/
  background-color: white;
  z-index: 2;
  background-size: cover;
  display: flex;
  flex-direction: column;
  padding-top: 20px;
  // justify-content: center;
  align-items: center;
  @media (max-width: 560px) {
    overflow: scroll;
    padding-bottom: 150px;
  }
}

input {
  border: 1px solid #993399;
  box-sizing: border-box;
  border-radius: 4px;
}

.input-group-append .input-group-text.change-visibility-span {
  background: white;
  border: 1px solid #993399;
  color: #993399;
}

.wrapper .login-card {
  border-radius: 3px;
  width: 350px;
  @media (max-width: 600px) {
    width: 80%;
  }
}

.login-card label {
  color: black;
}

.login-card .change-visibility-span:hover {
  cursor: pointer;
}

.login-card .login-card-header {
  display: flex;
  justify-content: center;
  img {
    width: 150px;
    height: 100%;
  }
}

.forgot-password {
  display: flex;
  color: #993399;
  margin: 20px 0px;
}

footer,
footer p {
  margin-top: 20px;
  color: #979797;
  max-width: 400px;
  font-size: 9px;
  @media (max-width: 560px) {
    width: 80%;
  }
}

label {
  font-weight: bold;
  color: white;
}

.btn {
  background: var(--primary-color);
  font-weight: bold;
  &:disabled {
    background: rgba(100, 100, 100, 1);
    opacity: 1;
    color: white;
  }
}

input[type="checkbox"].form-control {
  width: fit-content;
  margin-right: 10px;
}

.remember-me {
  display: flex;
  align-items: center;
}

a {
  color: #993399;
}
</style>
